<template>
  <v-app-bar app class="navbar-site white" :height="100">
    <v-container class="d-flex align-center w-100 position-relative">
      <v-btn text @click="goBack" class="px-4 flex-shrink-0 go-back-btn">
        <v-icon left>$chevronLeft</v-icon>
        Torna al carrello
      </v-btn>
      <router-link
        :to="{ name: 'Home' }"
        class="logo-link flex-shrink-0"
        :class="{
          'ml-auto': $vuetify.breakpoint.smAndDown,
          centered: $vuetify.breakpoint.mdAndUp
        }"
        aria-label="Torna alla homepage"
        title="Clicca per andare alla homepage"
      >
        <div class="logo-wrapper my-2">
          <img
            id="logo-coop-shop"
            class="logo"
            :src="serviceImg"
            alt="Logo Coop Shop"
          />
        </div>
      </router-link>
    </v-container>
  </v-app-bar>
</template>

<script>
import cartInfo from "~/mixins/cartInfo";

export default {
  name: "NavbarPayments",
  mixins: [cartInfo],
  props: {
    applicationConfig: { type: Object, required: false }
  },
  data() {
    return {
      bannerTopKey: 0
    };
  },
  methods: {
    closeBannerNews() {
      if (this.applicationConfig.categoryBlocks) {
        let headerNews = this.applicationConfig.categoryBlocks.find(
          block => block.templateBlock.codInt == "header"
        );
        if (headerNews) {
          let bannersTopShowingDate = {};
          bannersTopShowingDate[headerNews.categoryBlockId] = new Date(
            Date.now() + 3600 * 1000 * 24
          ).toISOString();
          window.sessionStorage["bannersTopShowingDate"] = JSON.stringify(
            bannersTopShowingDate
          );
        }
      }
      this.bannerTopKey++;
    },
    closeLogin() {
      this.$refs.loginMenuRef.isActive = false;
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  computed: {
    alreadyShowedNewsBanner() {
      this.bannerTopKey;
      if (this.applicationConfig.categoryBlocks) {
        let headerNews = this.applicationConfig.categoryBlocks.find(
          block => block.templateBlock.codInt == "header"
        );
        if (headerNews) {
          let bannersTopShowingDate = window.sessionStorage[
            "bannersTopShowingDate"
          ]
            ? JSON.parse(window.sessionStorage["bannersTopShowingDate"])
            : {};
          let catBlockId = headerNews.categoryBlockId;

          let nextOpeningDate = bannersTopShowingDate[catBlockId];
          let today = new Date();
          if (
            Object.prototype.hasOwnProperty.call(
              bannersTopShowingDate,
              catBlockId
            ) &&
            Date.parse(nextOpeningDate) > Date.parse(today)
          ) {
            // there is banner but close already clicked
            return true;
          }

          // show banner
          return false;
        } else {
          // there is no proposal -> do not show news banner
          return true;
        }
      }
      // there is no banner to show
      return true;
    }
  }
};
</script>

<style scoped lang="scss">
.navbar-site {
  height: 100px important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08) !important;
  .go-back-btn {
    text-transform: unset !important;
    font-weight: 400;
  }
}

.logo-link.centered {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.logo {
  width: 200px;
  height: 60px;
  @media (max-width: 599px) {
    width: 133px;
    height: 40px;
  }
}
</style>
